import { useContext } from "react";
import config from "../../config";
import { useMutation } from "@tanstack/react-query";
import { AppContext } from "@/App.context";


const setReporting = (token) => {
  return async ({ body, service,type, id }) => {
    const endpoint = type === "edit" ? `update/${id}` : "create";
    const setReporting = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/${endpoint}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(body),
      }
    );

    if (!setReporting.ok) {
      const errorResponse = await setReporting.json();
      throw new Error(errorResponse.message);
    }
    const data = await setReporting.json();

    return data;
  };
};

export const useCreateReport = (type) => {
  const appContext = useContext(AppContext);

  const mutation = useMutation({
    mutationKey: ["setReporting", type],
    mutationFn: (body) => setReporting(appContext.idToken)({ ...body, type }),
  });

  return mutation;
};
